import { z } from "zod";

export const BuyerCompanyFormSchema = z.object({
  companies: z.array(
    z.object({
      invoice_buyer_id: z.number().optional(),
      company_name: z.string().min(3, { message: "Company name is required" }),
      company_registration_number: z
        .string()
        .min(3, { message: "Registration number is required" }),
      company_address: z
        .string()
        .min(3, { message: "Company address is required" }),

      trading_history: z
        .string()
        .trim()
        .min(1, { message: "Years of trading is required" }),
      description_goods: z
        .string()
        .trim()
        .min(1, { message: "Description goods is required" }),
      currency: z
        .string()
        .trim()
        .min(2, { message: "Currency is required i.e. USD, EURO, INR" }),

      limit_request: z.preprocess(
        (arg) => (typeof arg === "string" ? Number(arg) : arg),
        z
          .number({ message: "Expect a number" })
          .min(1, "Enter a valid Limit request amount")
          .max(100000000)
      ),

      inco_terms: z
        .string()
        .trim()
        .min(3, { message: "inco terms is required" }),

      payment_term_1: z.object({
        percentage: z
          .string()
          .trim()
          .min(1, { message: "Percentage is required" }),
      }),
      payment_term_2: z.object({
        days: z.string().trim().min(1, { message: "Days is required" }),
        percentage: z
          .string()
          .trim()
          .min(1, { message: "Percentage is required" }),
      }),
      payment_term_3: z.object({
        days: z.string().trim().min(1, { message: "Days is required" }),
        percentage: z
          .string()
          .trim()
          .min(1, { message: "Percentage is required" }),
      }),
      payment_term_4: z.object({
        days: z.string().trim().min(1, { message: "Days is required" }),
        percentage: z
          .string()
          .trim()
          .min(1, { message: "Percentage is required" }),
      }),
    })
  ),
  terms_conditions_1: z.boolean().refine((value) => value === true, {
    message: "You must accept the terms and conditions",
  }),
  terms_conditions_2: z.boolean().refine((value) => value === true, {
    message: "You must accept the terms and conditions.",
  }),
});

export type BuyerCompanyFormType = z.infer<typeof BuyerCompanyFormSchema>;

export const CreditLimitFormSchema = z.object({
  limit_request: z.preprocess(
    (arg) => (typeof arg === "string" ? Number(arg) : arg),
    z
      .number({ message: "Expect a number" })
      .min(1, "Enter a valid Limit request amount")
      .max(100000000)
  ),
  // payment_terms: z.string().min(3, { message: "Payment terms is required" }),
  inco_terms: z.string().min(3, { message: "inco terms is required" }),

  // terms_conditions_1: z.boolean().refine((value) => value === true, {
  //   message: "You must accept the terms and conditions",
  // }),
  // terms_conditions_2: z.boolean().refine((value) => value === true, {
  //   message: "You must accept the terms and conditions.",
  // }),
  // company_name: z.string().min(3, { message: "Company name is required" }),
  // reg_no: z.string().min(3, { message: "Registration number is required" }),
  // company_address: z
  //   .string()
  //   .min(3, { message: "Company address is required" }),
});

export type CreditLimitFormType = z.infer<typeof CreditLimitFormSchema>;
